export const subscriptionStatuses = {
  NO_SUBSCRIPTION: 'NO_SUBSCRIPTION',
  ACTIVE: 'ACTIVE',
  ACTIVE_TRIAL: 'ACTIVE_TRIAL',
  ACTIVE_CANCELLED: 'ACTIVE_CANCELLED',
  ENDED: 'ENDED',
  ENDED_TRIAL: 'ENDED_TRIAL',
  ENDED_CANCELLED: 'ENDED_CANCELLED',
};
